export default function auth({ next, router }) {
  if (!!(localStorage.getItem('session') || sessionStorage.getItem('session'))) {
    return next({ name: 'evaluations' });
  }
  return next();
}